'use strict'
import { TweenMax, Power4 } from 'gsap'

export default {
  mode: 'out-in',
  enter: function (el, done) {
    TweenMax.fromTo(el, 0.8, { opacity: 0, paddingTop: 30 }, {
      opacity: 1,
      paddingTop: 0,
      ease: Power4.easeOut,
      onComplete: function () {
        window.setTimeout(() => {
          done()
        }, 200)
      }
    })
  },
  leave: function (el, done) {
    TweenMax.fromTo(el, 0.7, { opacity: 1 }, {
      opacity: 0,
      paddingTop: 30,
      ease: Power4.easeOut,
      onComplete: function () {
        done()
      }
    })
  }
}
